import { Dispatch, SetStateAction, useCallback } from 'react'

const useSelectCallback = (
  update: Dispatch<SetStateAction<string>>,
  setIsEdited?: Dispatch<SetStateAction<boolean>>
) => {
  return useCallback(
    (value: string) => {
      update(value)
      setIsEdited && setIsEdited(true)
    },
    [update, setIsEdited]
  )
}

export default useSelectCallback
